export default __webpack_public_path__ + "static/media/14_fireflies.47b577e0.JPG";